<template>
  <div style="background-color: #f4fbff">
    <Header :leftArrow="true" @leftClick="onBack" @onRefreshClick="onRefresh"> </Header>
    <div>
      <div class="home_notice-search">
      <van-dialog
          v-model:show="searchModalShow"
          title="並び替え"
          @confirm="searchList"
      >
        <div id="search-modal ">
          <div class="search-modal_inner">
            <div class="search-modal_list">
              <input type="radio" id="all" value="all" v-model="search.online_type"/>
              <label for="all" class="radio">すべて</label>
              <input type="radio" id="online" value="online" v-model="search.online_type"/>
              <label for="online" class="radio">ONLINE</label>
              <input type="radio" id="offline" value="offline" v-model="search.online_type"/>
              <label for="offline" class="radio">OFFLINE</label>
              <p class="search-modal_title-sub">詳細設定</p>
              <input type="checkbox" id ="abc" v-model="abcSort"/>
              <label for="abc" class="checkbox">あいうえお順</label>
            </div>
          </div>
        </div>
      </van-dialog>

      <form method="get" style="margin-top: 20px">
        <input
            v-model="this.search.name"
            type="search"
            name="search"
            placeholder="ユーザーを検索"
        />
        <input
            type="submit"
            onclick="return false;"
            name="submit"
            value="検索"
            @click="searchList"
        />
      </form>
      <div class="search-btn search-btn_user" @click="showSearch" style="margin-top: 20px">
        <span>並び替え</span>
      </div>
    </div>
      <div
          class="home_past-notice home_user-team"
          v-for="(group, key) in groupPatientList"
          :key="key"
          v-if="abcSort"
      >
        <p class="title-days title-user_abc">
          {{ key }}
        </p>
        <div class="monitor-list watch">
          <div class="watch_wrap">
            <div class="watch-list">
              <div
                  class="watch-item"
                  v-for="item in group"
                  :key="item"
                  @click="goPatientDetail(item)"
              >
                <div class="watch-item_img">
                  <div  v-show="item.photo =='white' || item.photo =='show' " class="online">ONLINE</div>
                  <div  v-show="item.photo =='gray' " class="offline">OFFLINE</div>
                </div>
                <p class="watch-item_info">
                  <span class="watch-item_name"><span>{{ item.name }}</span><span class="online-class" v-show="item.photo =='white' || item.photo =='show' "></span></span>
<!--                  <span class="watch-item_date" v-show="item.photo =='show'">{{ item.startDate }} {{ item.startTime }}</span>-->
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="monitor-list watch" v-if="!abcSort">
      <div class="watch_wrap">
        <div class="watch-list">
          <div
            class="watch-item"
            v-for="item in patientList"
            :key="item"
            @click="goPatientDetail(item)"
          >
            <div class="watch-item_img">
              <div  v-show="item.photo =='white' || item.photo =='show' " class="online">ONLINE</div>
              <div  v-show="item.photo =='gray' " class="offline">OFFLINE</div>
            </div>
            <p class="watch-item_info">
              <span class="watch-item_name"><span>{{ item.name }}</span><span class="online-class" v-show="item.photo =='white' || item.photo =='show' "></span></span>
              <span class="watch-item_date" v-show="item.photo =='show'">{{ item.startDate }} {{ item.startTime }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    </div>
<!--    <Footer />-->
  </div>
</template>

<script>
  import Footer from "@/components/Footer.vue";
  import Header from "@/components/Header.vue";
  import {Toast} from "vant";
  import "vant/es/toast/style";
  import {GetPatientDetails, GetPatientMonitorList} from "@/services/patient";

  export default {
  data() {
    return {
      patientList: [],
      groupPatientList: [],
      refreshTimer: null,
      // 检索用
      search: {
        name: "",
        online_type:"all",
      },
      abcSort:false,
      searchModalShow: false,
    };
  },
  components: {
    Footer,
    Header,
  },
  mounted() {
    this.initPatientList();
    this.refreshTimer = setInterval(() => {
      //30s 监视模式下，30s刷新数据。
      this.initPatientList();
    }, 30000);
  },
  beforeUnmount() {
    if(this.refreshTimer){
      clearInterval(this.refreshTimer);
    }
  },
  methods: {
    onBack(){
      history.back();
    },
    searchList(){
      this.initPatientList();
    },
    showSearch() {
      this.searchModalShow = true;
    },
    // getImgUrl(item) {
    //   return (
    //     process.env.VUE_APP_API_CMS_BASE_URL + process.env.VUE_APP_SERVER_MONITOR_PATH +
    //     item.medical_id + "_" + item.patient_id + "_" + item.name + ".png");
    // },
    onRefresh() {
      Toast.loading({
        message: "",
        forbidClick: true,
        duration: 1000,
      });
    },
    initPatientList() {
      GetPatientMonitorList({search:this.search}).then((res) => {
        let list =  res.data.data || [];
        list.forEach( (item)=> {
          if (process.env.NODE_ENV === "development") {
            item.imgSrc = "api/" + item.imgSrc+ '?' + new Date().getTime();
          }else{
            item.imgSrc = item.imgSrc+ '?' + new Date().getTime();
          }
          if(item.online_status !== 'online'){
            item.photo = 'gray'
          }else if(item.calling_status == '6'){
            item.photo = 'show'
          }else if(item.monitor_open_flg !=='1'){
            item.photo = 'gray'
          }else{
            item.photo = 'white'
          }
        });
        if(this.abcSort){
          this.initGroupPatientList(list);
        }else{
          this.patientList = list;
        }
      });
    },
    initGroupPatientList(list){
      if(list && list.length>0){
        console.log(this.patientList);
        // 按照kana分组
        const alphabet = [
          "あ", "い", "う", "え", "お", "か", "き", "く", "け", "こ",
          "さ", "し", "す", "せ", "そ", "た", "ち", "つ", "て", "と",
          "な", "に", "ぬ", "ね", "の", "は", "ひ", "ふ", "へ", "ほ",
          "ま", "み", "む", "め", "も", "や", "ゆ", "よ",
          "ら", "り", "る", "れ", "ろ", "わ", "を", "ん"
        ];
        const groupedContacts = {};
        groupedContacts["#"] = [];
        list.forEach((item) => {
          if (!item.kana || !alphabet.includes(item.kana.charAt(0))) {
            groupedContacts["#"].push(item);
            return;
          }
          const firstChar = item.kana.charAt(0);
          if (!groupedContacts[firstChar]) {
            groupedContacts[firstChar] = [];
          }
          groupedContacts[firstChar].push(item);
        });
        this.groupPatientList = groupedContacts;
      }else{
        this.groupPatientList = [];
      }
    },
    goPatientDetail(item) {
      GetPatientDetails(item.patient_id).then((res) => {
        const patientInfo = res.data.data.detail;
        if(patientInfo){
          if(patientInfo.online_status !== 'online'){
            Toast("相手はオンラインではありません。");
          }else if(patientInfo.monitor_status !== "monitored" && patientInfo.monitor_open_flg !=='1'){
            Toast("相手方の見守権限がオープンしていません。");
          }else if(patientInfo.calling_status != '3' && patientInfo.calling_status != '6'){
            Toast("相手方は現在通話中。");
          }else{
            this.$emit("monitor",{toPage:"monitor",method:"openPatientMonitor",patient_id:patientInfo.patient_id
              ,id:patientInfo.id});
          }
        }else{
          Toast("データ異常。");
        }
      });
    },
    onClickLeft() {
      history.back();
    },
  },
  watch: {},
};
</script>

<style scoped>
.monitor-list{
  padding:5px 15px 15px;
}
.monitor-list .watch-item{
  margin-top: 5px;
}
.patient-item img {
  width: 100%;
  height: 83%;
  border-radius: 10px 10px 0 0;
}
.online{
  display: grid;
  justify-items: center;
  align-items: center;
  width: calc((100% - 24px));
  height: 100px;
  background-color: var(--van-white);
}
.offline{
  display: grid;
  justify-items: center;
  align-items: center;
  width: calc((100% - 24px));
  height: 100px;
  background-color: gainsboro;
}
.online-class{
  font-weight: 400;
  font-size: 11px;
  line-height: 1.5;
  padding-left: 10px;
  position: relative;
  margin-left: 5px;
}
.online-class::before{
  content: "";
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  background: #00A900;
}
</style>
